module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/.pnpm/echo-loader@0.0.1/node_modules/echo-loader/echo-loader.js!../../../../../../node_modules/.pnpm/babel-loader@9.1.3_@babel+core@7.24.8_webpack@5.93.0/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[1].use[1]!./editMarketList.jsx"));
	}, "home");
}